export enum BASIC_DROPDOWN_DROP {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum BASIC_DROPDOWN_ALIGN {
  START = 'start',
  END = 'end',
}

export enum BASIC_DROPDOWN_SIZE {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
